import {
  CreatePaymentMethodRequest,
  UpdatePaymentMethodMetadataRequest,
} from './requests/payment-method-request.ts';
import { apiClient } from './client.tsx';
import {
  CreatePaymentMethodResponse,
  GetPaymentMethodListResponse,
  GetPaymentMethodResponse,
  UpdatePaymentMethodMetadataResponse,
} from './responses/payment-method-response.ts';

export const createPaymentMethod = (request: CreatePaymentMethodRequest) =>
  apiClient
    .post<CreatePaymentMethodResponse>(`/v2/payment_methods`, request)
    .then((res) => res.data.data);

export const getPaymentMethod = (paymentMethodId: string) =>
  apiClient
    .get<GetPaymentMethodResponse>(`/v2/payment_methods/${paymentMethodId}`)
    .then((res) => res.data.data);

export const getPaymentMethodList = () =>
  apiClient
    .get<GetPaymentMethodListResponse>('/v2/payment_methods')
    .then((res) => res.data.data);

export const updatePaymentMethodMetadata = (
  request: UpdatePaymentMethodMetadataRequest,
) =>
  apiClient
    .put<UpdatePaymentMethodMetadataResponse>(
      `/v2/payment_methods/${request.paymentMethodId}`,
      request,
    )
    .then((res) => res.data.data);

export const removePaymentMethod = (paymentMethodId: string) =>
  apiClient.delete(`/v2/payment_methods/${paymentMethodId}`);
